import { render, staticRenderFns } from "./Inventory.container.vue?vue&type=template&id=6bbdb416&scoped=true&"
import script from "./Inventory.container.vue?vue&type=script&lang=js&"
export * from "./Inventory.container.vue?vue&type=script&lang=js&"
import style0 from "./Inventory.container.vue?vue&type=style&index=0&id=6bbdb416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbdb416",
  null
  
)

export default component.exports